import MeetingRoomSearch from './MeetingRoomSearch';
import Route from './route';

export default {
  RenderProp: MeetingRoomSearch,
  mainRoute: Route,
};
